<template>
  <div class="line">
    <div>{{factory.business_name}}</div>
    <div>{{factory.website}}</div>
    <div>{{factory.phone}}</div>
    <span class="actions">
      <i @click="editFactory" class="material-icons">edit</i>
      <i @click="deleteFactory" class="material-icons">delete</i>
    </span>
  </div>
</template>

<script>
import {store} from '@/store'
export default {
  name: 'FactoryEntry',
  props: {
    factory: Object
  },
  methods: {
    editFactory: function(){
      store.commit('setnewfactory', this.factory)
    },
    deleteFactory: function(){
      if(confirm('Are you sure you want to delete this factory?')){
        store.dispatch('deleteFactory', this.factory.id)
      }
    }
  }
}
</script>

<style scoped lang="less">

.line {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  border-bottom: dashed 1px lightgray;
  align-items: center;
  font-size: 0.9em;
  box-sizing: border-box;
  div {
    width: calc(100% / 3);
    padding: 12px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .actions {
    display: block;
    box-sizing: border-box;
    padding: 6px;
    width: 60px;
    i {
      font-size: 18px !important;
      cursor: pointer;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/factories/FactoryEntry.vue